
export const data = [
    {
        image:'https://orderserv-kfc-assets.yum.com/15895bb59f7b4bb588ee933f8cd5344a/images/categories/CAT86.jpg?ver=20.89',
        title:'CHICKEN BUCKETS'
    },
    {   
        image:'https://orderserv-kfc-assets.yum.com/15895bb59f7b4bb588ee933f8cd5344a/images/categories/CAT200.jpg?ver=20.89',
        title:'NEW LAUNCH'
    },
    {
        image:'https://orderserv-kfc-assets.yum.com/15895bb59f7b4bb588ee933f8cd5344a/images/categories/CAT190.jpg?ver=20.89',
        title:'BIRYANI BUCKETS'
    },
    {
        image:'https://orderserv-kfc-assets.yum.com/15895bb59f7b4bb588ee933f8cd5344a/images/categories/CAT158.jpg?ver=20.89',
        title:'BOX MEALS'
    },
    {
        image:'https://orderserv-kfc-assets.yum.com/15895bb59f7b4bb588ee933f8cd5344a/images/categories/CAT99.jpg?ver=20.89',
        title:'BURGERS'
    },
    {
        image:'https://orderserv-kfc-assets.yum.com/15895bb59f7b4bb588ee933f8cd5344a/images/categories/CAT178.jpg?ver=20.89',
        title:'STAY HOME SPECIALS'
    },
    {
        image:'https://orderserv-kfc-assets.yum.com/15895bb59f7b4bb588ee933f8cd5344a/images/categories/CAT89.jpg?ver=20.89',
        title:'SNACKS'
    }
]